import { render, staticRenderFns } from "./bot-form.vue?vue&type=template&id=5f26d8bb&scoped=true&"
import script from "./bot-form.vue?vue&type=script&lang=js&"
export * from "./bot-form.vue?vue&type=script&lang=js&"
import style0 from "./bot-form.vue?vue&type=style&index=0&id=5f26d8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26d8bb",
  null
  
)

export default component.exports